<div class="card-alert">
    <div class="alert alert-dismissible fade" role="alert" *ngIf="messageModel.showAlert"
        [ngClass]="messageModel.alertClass">
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
            (click)="messageModel.close()">
        </button>
        <strong>
            {{ messageModel.title }}
        </strong>
        {{ messageModel.message }}
    </div>
</div>